import { render, staticRenderFns } from "./EmptyProductsMessage.vue?vue&type=template&id=23cdbce3&scoped=true&"
import script from "./EmptyProductsMessage.vue?vue&type=script&lang=js&"
export * from "./EmptyProductsMessage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyProductsMessage.vue?vue&type=style&index=0&id=23cdbce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cdbce3",
  null
  
)

export default component.exports